import React, {useContext} from "react";
import {store} from "./store";

const CardConnectTokenizer = () => {
    const globalState = useContext(store);
    const {env} = globalState.state;
    const params = '?useexpiry=true&usecvv=true&invalidinputevent=true&highlightinvalidinput=true&tokenizewheninactive=true&inactivityto=500&unique=true';
    let url = 'https://fts.cardconnect.com/itoke/ajax-tokenizer.html';

    if (env === 'dev') {
        url = 'https://fts-uat.cardconnect.com/itoke/ajax-tokenizer.html';
    }

    url = url + params;

    return (
        <iframe
            id="tokenframe3"
            name="tokenframe"
            src={url}
            scrolling="no"
            width="200"
            height="160"
            title="ftdt-cc-tokenizer"
            frameBorder="0"
        />
    );
};

export default CardConnectTokenizer;
